import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import authClient from '../../auth';
import hideMessage from '../../HideMessage';
import { Badge, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem,
  Button,Form,FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  Container,Row,Col, CardBody, Label, Modal as SystemModal } from 'reactstrap';
import PropTypes from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import {
  AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler, AppSwitch } from '@coreui/react';
import Modal from 'react-responsive-modal';
import Phone from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import AGILITYLOGO from '../../assets/img/agility_logo.png';
import AGILITYLOGO_WEBP from '../../assets/img/agility_logo.webp';
import LOGINBG from '../../assets/img/login/icon-01.png';
import '../../views/AgilityThinking/AgilityThinking.scss';

const DefaultHeader = { "authorization": "Token " + localStorage.getItem('student_authenticity_token') }

const defaultProps = {};
const propTypes = {
  children: PropTypes.node,
};

class DefaultProductHeader extends Component {
  constructor(props) {
    super(props);

    this.handleLoginSubmit = this.handleLoginSubmit.bind(this);
    this.handleForgotPassword = this.handleForgotPassword.bind(this);
    this.generateOTP = this.generateOTP.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.handleChangeLogin = this.handleChangeLogin.bind(this);
    this.handleSignupPhone = this.handleSignupPhone.bind(this);
    this.handleChangeEdit = this.handleChangeEdit.bind(this);
    this.handleProfileSubmit = this.handleProfileSubmit.bind(this);
    this.createUserAccount = this.createUserAccount.bind(this);
    this.skipProfileSubmit = this.skipProfileSubmit.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.subscribeToNewsLetter = this.subscribeToNewsLetter.bind(this);
    this.newsLetterToggle = this.newsLetterToggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.toggleContactModal = this.toggleContactModal.bind(this);
    this.handleEnquiry = this.handleEnquiry.bind(this);
    this.handleEnquiryChange = this.handleEnquiryChange.bind(this);
    this.handleEnquiryPhone = this.handleEnquiryPhone.bind(this);
    this.state = {
      loginopen: false,
      tags: {},
      student: {},
      user: {tags: []},
      users: {},
      subscriber_email: "",
      login_form_visibility: 'block',
      signup_form_visibility: 'none',
      width: window.innerWidth,
      otp: 'none',
      loginbtn: 'none',
      otpbtn: 'block',
      paddingBottom: '7rem',
      update_form_visibility: 'none',
      forgot_form_visibility: 'none',
      newsletteropen: false,
      contactopen: false,
      enquiry: {},
    }
  };
  openUrl(url) {
    window.open(url);
  }
  componentDidMount() {
    var login_value = localStorage.getItem('login_value');
    if (login_value == "true"){
      hideMessage.displaySuccessMsg('You have been successfully logged in to Leanpitch.')
      localStorage.setItem('login_value', false);
    }
    var logout_value = localStorage.getItem('logout_value');
    if (logout_value == "true"){
      hideMessage.displaySuccessMsg('You have been successfully logged out from Leanpitch.')
      localStorage.setItem('logout_value', false);
    }
  }
  createUserAccount() {
    let someProperty = {...this.state.student}
    someProperty['username'] = someProperty.email;
    axios.post(process.env.REACT_APP_STUDENT_API,someProperty,{headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
    }).then(res => {
      if (res.data['non_field_errors'] != undefined) {
            }else {
              this.setState({loginopen: false, update_form_visibility: 'none'})
              hideMessage.displaySuccessMsg('You are just one step away from awesomeness! Confirmation link has been sent to your email, Please confirm your account.')
            }
    }).catch(error => {
      if(error.response){
        let error_messages = ""
        for (var key in error.response.data){
          error_messages += error.response.data[key] + "<br>"
        }
        hideMessage.displayErrorMsg(error_messages)
      }
    });
  }
  handleLoginSubmit(event){
    event.preventDefault();
    var someProperty = {...this.state.student}
    var password_valid = document.getElementById('signup_password').value;
    var password_error = 'Ensure password field has minimum 8 characters';
    if (password_valid.length >= 8){
      this.setState({ signup_form_visibility: 'none', update_form_visibility: 'block' })
    }else{
      hideMessage.displayErrorMsg(password_error)
   }
  }
  handleProfileSubmit(event) {
    event.preventDefault();
    if (this.state.student.email) {
      this.createUserAccount();
    }
  }
  skipProfileSubmit() {
    if (this.state.student.email) {
      this.createUserAccount();
    }
  }
  handleLogin(event) {
    event.preventDefault();
    var someProperty = {...this.state.student}
    authClient.GetKey({username: this.state.student.email.toLowerCase(), password: someProperty.password })
  }
  handleForgotPassword(event) {
    event.preventDefault();
    var someProperty = {...this.state.student}
    authClient.loginUsingOTP({email: this.state.student.email.toLowerCase() ,otp: this.state.student.otp })
  }
  generateOTP(event){
    if(this.state.student.email && this.state.student.email.length > 0){
      var someProperty = {...this.state.student}
      authClient.generateOTP({email: this.state.student.email.toLowerCase() })
      this.setState({otp: 'block', loginbtn: 'block', otpbtn: 'none', paddingBottom: '6rem'});
    }else{
      hideMessage.displayErrorMsg('Please enter a valid email address.')
    }
  }
  openLoginForm(event) {
    this.setState({login_form_visibility: 'block', signup_form_visibility: 'none', otp: 'none', loginbtn: 'none', otpbtn: 'block', paddingBottom: '6rem', update_form_visibility: 'none', forgot_form_visibility: 'none'});
  }
  openSignup(event) {
    this.setState({login_form_visibility: 'none', signup_form_visibility: 'block', otp: 'none', loginbtn: 'none', otpbtn: 'block', paddingBottom: '6rem', update_form_visibility: 'none', forgot_form_visibility: 'none'});
  }
  openForgotForm(event) {
    this.setState({login_form_visibility: 'none', signup_form_visibility: 'none', otp: 'none', loginbtn: 'none', otpbtn: 'block', paddingBottom: '6rem', update_form_visibility: 'none', forgot_form_visibility: 'block'});
  }
  handleChangeLogin(event) {
    var someProperty = {...this.state.student}
    if(event.target){
      someProperty[event.target.name] = event.target.value;
    }else{
      someProperty.detail = event;
    }
    this.setState({student: someProperty})
  }
  handleSignupPhone(value) {
    var someProperty = {...this.state.student};
    if (document.getElementById('signup_phone')) {
      someProperty['phone'] = value;
    }
    this.setState({student: someProperty});
  }
  handleChangeEdit(event) {
    var someProperty = {...this.state.user}
    someProperty[event.target.name] = event.target.value;
    this.setState({user: someProperty})
  }
  formFieldFocus(field) {
    let form_field = document.getElementById(field);
    if (form_field) {
      form_field.focus();
    }
  }
  componentWillUnmount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }
  toggleModal() {
    this.setState({loginopen: !this.state.loginopen, login_form_visibility: 'block', signup_form_visibility: 'none',
      update_form_visibility: 'none', forgot_form_visibility: 'none'})
  }
  handleChange(event){
    if(event.target){
      this.state.subscriber_email = event.target.value;
    }
  }
  newsLetterToggle(){
    this.setState({newsletteropen: !this.state.newsletteropen})
  }
  formFieldFocus(field){
    let form_field = document.getElementById(field);
    if (form_field) {
      form_field.focus();
    }
  }
  subscribeToNewsLetter(event){
    event.preventDefault();
    if (this.state.subscriber_email != ''){
      let email = this.state.subscriber_email;
      let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,})+$/;
      if (email.match(mailformat)) {
        var string_data = {
          email: this.state.subscriber_email,
          type: "agility_thinking",
          message: "agility thinking newsletter"
        }
        let formData = new FormData();
        for(var k in string_data){
          formData.append(k,string_data[k])
        }
        axios.post(process.env.REACT_APP_ENQUIRY , formData)
        .then(res => {
          if (res.data['non_field_errors'] != undefined) {
            hideMessage.displayErrorMsg(res.data['non_field_errors'])
          } else {this.setState({enquiry: {}, newsletteropen: false})
          hideMessage.displaySuccessMsg('Thank you for subscribing!');
          }
        }).catch(error => {
          this.setState({enquiry: {}, newsletteropen: false})
          if(error.response){
            let error_messages = error.response.statusText + "<br>"
            for (var key in error.response.data){
              error_messages += error.response.data[key] + "<br>"
            }
            hideMessage.displayErrorMsg(error_messages)
          }
          if(!error.response){
            hideMessage.displayErrorMsg('Please check your internet connection')
          }
        });
      } else {
        hideMessage.displayErrorMsg('Please provide valid email id!')
        this.formFieldFocus('subscribe_for_news_letter')
      }
    }
  }
  toggleContactModal() {
    this.setState({contactopen: !this.state.contactopen})
  }
  handleEnquiry(event) {
    event.preventDefault();
    if (this.state.enquiry.email) {
      let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,})+$/;
      if (this.state.enquiry.email.match(mailformat)) {
        let formData = new FormData();
        formData.append('name',this.state.enquiry.name)
        formData.append('email',this.state.enquiry.email)
        formData.append('phone',this.state.enquiry.mobile)
        formData.append('message',this.state.enquiry.message)
        formData.append('type', 'agility_thinking_contact')
        axios.post(process.env.REACT_APP_ENQUIRY , formData)
        .then(res => {
          if (res.data['non_field_errors'] != undefined) {
            hideMessage.displayErrorMsg(res.data['non_field_errors'])
          } else {
            let name = this.state.enquiry.name;
            this.clearForm();
            this.setState({enquiry: {}, contactopen: false})
            hideMessage.displaySuccessMsg('Thank you '+name+' for contacting us. We received your message. <br>Our team will contact you shortly!');
          }
        }).catch(error => {
          this.setState({enquiry: {}, contactopen: false})
          if(error.response){
            let error_messages = error.response.statusText + "<br>"
            for (var key in error.response.data){
              error_messages += error.response.data[key] + "<br>"
            }
            hideMessage.displayErrorMsg(error_messages)
          }
          if(!error.response){
            hideMessage.displayErrorMsg('Please check your internet connection')
          }
        });
      } else {
        hideMessage.displayErrorMsg('Please provide valid email id')
      }
    } else {
      hideMessage.displayErrorMsg('Please provide email id')
    }
  }
  clearForm(){
    if(document.getElementById('enquiry_name'))document.getElementById('enquiry_name').value = ''
    if(document.getElementById('enquiry_email'))document.getElementById('enquiry_email').value = ''
    if(document.getElementById('enquiry_phone'))document.getElementById('enquiry_phone').value = ''
    if(document.getElementById('enquiry_preferred_location'))document.getElementById('enquiry_preferred_location').value = ''
    if(document.getElementById('enquiry_preferred_courses'))document.getElementById('enquiry_preferred_courses').value = ''
    if(document.getElementById('enquiry_message'))document.getElementById('enquiry_message').value = ''
  }
  handleEnquiryChange(event) {
    var someProperty = {...this.state.enquiry}
    if(event.target){
      someProperty[event.target.name] = event.target.value;
    }else{
      someProperty.detail = event;
    }
    this.setState({enquiry: someProperty})
  }
  handleEnquiryPhone(value) {
    var someProperty = {...this.state.enquiry};
    if (document.getElementById('enquiry_phone')) {
      someProperty['mobile'] = value;
    }
    this.setState({enquiry: someProperty});
  }
  render() {

    // eslint-disable-next-line
    const { children, ...attributes } = this.props;
    const contact_style ={
        "maxWidth": "351px",
        "marginRight": "0px"
    }
    return (
      <Row className="m-auto w-100 overlay-div" style={{position: 'relative' }}>
        <p className="hidden" id="login" onClick={this.toggleModal}>Login</p>
        <div className="overlay" style={{borderRadius: '0', cursor: 'auto', backgroundColor: 'rgb(35, 100, 132)', boxShadow: '0 5px 5px 2px rgba(0, 0, 0, 0.2)'}} id="header_overlay"></div>
        <Col sm="2" md="2" lg="2" className="float-left px-0 overlay-div py-2" style={{maxWidth: '70px'}}>
          <a href="/">
            <picture>
              <source type="image/webp" srcSet={AGILITYLOGO_WEBP} />
              <LazyLoadImage src={AGILITYLOGO} alt="product_thinking" height="65" />
            </picture>
          </a>
        </Col>
        <Col sm="3" md="3" lg="3" className="float-left px-0 overlay-div my-auto" style={{verticalAlign: 'middle'}}>
          <a href="/"><h2 className="bold float-left mb-0 text-white">Agility Thinking</h2></a>
        </Col>
        <Col sm="2" md="2" lg="2" className="offset_product_thinking float-right px-0 overlay-div text-white pointer" style={{backgroundColor: 'rgb(1, 49, 74)', maxWidth: '175px', display: 'flex'}} onClick={this.newsLetterToggle}>
          <h2 className="text-center m-auto" style={{verticalAlign: 'middle'}}>Subscribe</h2>
        </Col>
        <Col sm="2" md="2" lg="2" className="float-right px-0 overlay-div text-white my-auto pointer" style={{ maxWidth: '175px', verticalAlign: 'middle'}} onClick={this.toggleContactModal}>
          <h2 className="text-center mb-0">Contact Us</h2>
        </Col>
        <SystemModal zIndex="996"  modalClassName="modal-product-thinking" isOpen={this.state.newsletteropen} toggle={this.newsLetterToggle} center=
        "true" >
          <Col xs="12" sm="12" lg="12">
            <i className="fa fa-times-circle-o" aria-hidden="true" onClick={this.newsLetterToggle}></i>
          </Col>
          <Row className="m-0">
            <Col md="12" sm="12" className="float-left text-center pt-5 pb-4 px-0">
              <Form onSubmit={this.subscribeToNewsLetter}>
                <FormGroup row className="col-12 center referal-form px-0">
                  <Col lg="12" sm="12" md="12" className="float-left">
                    <h4 className="bold text-left text-primary bold"> Subscribe to Newsletter </h4>
                  </Col>
                  <Col md="12" className="float-left">
                    <FormGroup>
                      <Input className="input-material-black box-shadow-none text-black" type="text" name="email" defaultValue={this.state.subscriber_email} onChange={this.handleChange} id="subscribe_for_news_letter" placeholder="Your Email Id" required/>
                    </FormGroup>
                  </Col>
                </FormGroup>
                <Col md="10" className="padding-top-20 referal-form center">
                  <Button color="primary" type="submit" className="btn btn-pill rounded-bordered" style={{fontSize: '1.1rem'}}>Subscribe To Newsletter</Button>
                </Col>
              </Form>
            </Col>
          </Row>
        </SystemModal>
        <Modal classNames={{modal: 'modal-login'}} closeButton={'avcc'} open={this.state.loginopen} onClose={this.toggleModal} center >
          <section style={{display: 'flex'}}>
            <Row className="w-100" style={{display: 'flex'}}>
              <Col md="5" sm="5" className="float-left p-0 bg-blue-login" style={{borderRadius: '15px 0px 0px 15px', display: 'block'}}>
                <Col md="12" sm="12" style={{ backgroundImage: `url(${LOGINBG})`, height: 'calc(75%)' }}>
                </Col>
                <h1 className="bold text-white bg-blue-login m-0" style={{borderRadius: '0px 0px 0px 15px', padding: '10px 0px 0px 20px', display: 'block', maxHeight: 'calc(25%)'}}>Dive In to Awesomeness</h1>
              </Col>
              <Col md="7" sm="7" className="text-center px-5 pb-0 pt-5">
                <Form onSubmit={this.handleLoginSubmit} id="signup_form" style={{display:this.state.signup_form_visibility}} className="pb-5" >
                  <FormGroup row className="col-10 center">
                    <h5 className="bold text-left blue-color bold mt-2" style={{paddingLeft: '20px', paddingBottom: '20px'}}> Create Your Account </h5>
                    <Col md="12" className="">
                      <FormGroup>
                        <Input className="input-material-black box-shadow-none" type="text" name="first_name" defaultValue={this.state.student.first_name} onChange={this.handleChangeLogin} id="first_name" placeholder="Enter your name" required />
                      </FormGroup>
                    </Col>
                    <Col md="12" className="">
                      <FormGroup>
                        <Input className="input-material-black box-shadow-none" type="email" name="email" defaultValue={this.state.student.email} onChange={this.handleChangeLogin} id="email" placeholder="Email Id" required />
                      </FormGroup>
                    </Col>
                    <Col md="12" className="">
                      <FormGroup>
                        <Input className="input-material-black box-shadow-none" type="password" name="password" defaultValue={this.state.student.password} onChange={this.handleChangeLogin} id="signup_password" placeholder="Password (minimum 8 characters)" required />
                      </FormGroup>
                    </Col>
                  </FormGroup>
                  <Col md="10" className="center px-0" style={{marginBottom: '2.5rem'}}>
                    <Button type="submit" color="primary" className="btn btn-pill ounded-bordered buybtn" style={{fontSize: '1.1rem'}}>Next</Button>
                  </Col>
                  <Col md="10" className="center px-0">
                    <Button onClick={() => {this.openLoginForm()}}  color="primary" className="mb-2 btn btn-pill rounded-bordered buybtn loginformbtn">Already have an account?</Button>
                    <Button onClick={() => {this.openForgotForm()}}  color="primary" className="mb-2 btn btn-pill m-l-10 rounded-bordered buybtn loginformbtn">Forgot Password? Login using OTP</Button>
                  </Col>
                </Form>
                <Form onSubmit={this.handleProfileSubmit} id="update_form" style={{display:this.state.update_form_visibility}} className="pb-5" >
                  <FormGroup row className="col-10 center">
                    <h5 className="bold text-left blue-color bold mt-2" style={{paddingLeft: '20px'}}> Update Your Profile </h5>
                    <Col md="12" className="padding-top-20">
                      <FormGroup>
                        <Phone className="input-material-black profile-phone box-shadow-none" type="text" name="phone" displayInitialValueAsLocalNumber country="IN" value={this.state.student.phone} onChange={this.handleSignupPhone} id="signup_phone" placeholder="Phone number" />
                      </FormGroup>
                    </Col>
                    <Col md="12" className="">
                      <FormGroup>
                        <Input className="input-material-black box-shadow-none" type="text" name="current_company" defaultValue={this.state.student.current_company} onChange={this.handleChangeLogin} id="current_company" placeholder="Your company name" />
                      </FormGroup>
                    </Col>
                    <Col md="12" className="">
                      <FormGroup>
                        <Input className="input-material-black box-shadow-none" type="text" name="designation" defaultValue={this.state.student.designation} onChange={this.handleChangeLogin} id="designation" placeholder="Your designation" />
                      </FormGroup>
                    </Col>
                    <Col md="12" className="">
                      <FormGroup>
                        <Input className="input-material-black box-shadow-none" type="text" name="reference_source" defaultValue={this.state.student.reference_source} onChange={this.handleChangeLogin} id="reference_source" placeholder="From where have you heard of us?" />
                      </FormGroup>
                    </Col>
                  </FormGroup>
                  <Row className="col-md-10 center" style={{marginBottom: '2.5rem'}}>
                    <div className="col-sm-6 col-md-6 col-lg-6 px-0">
                      <Button type="submit" color="primary" className="btn btn-pill rounded-bordered buybtn mb-2 float-left" style={{fontSize: '1.1rem'}}>Next</Button>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6 px-0">
                      <Button onclick={this.skipProfileSubmit} color="primary" className="btn btn-pill m-l-10 rounded-bordered buybtn mb-2 float-right loginformbtn" style={{fontSize: '1.1rem'}}>Skip</Button>
                    </div>
                  </Row>
                  <Col md="10" className="center px-0">
                    <Button onClick={() => {this.openLoginForm()}}  color="primary" className="mb-2 btn btn-pill rounded-bordered buybtn loginformbtn">Already have an account?</Button>
                    <Button onClick={() => {this.openForgotForm()}}  color="primary" className="mb-2 btn btn-pill m-l-10 rounded-bordered buybtn loginformbtn">Forgot Password? Login using OTP</Button>
                  </Col>
                </Form>
                <Form onSubmit={this.handleLogin} id="signin_form" style={{display:this.state.login_form_visibility}} className="pb-5">
                  <FormGroup row className="col-10 center referal-form" id="referal-form">
                    <h5 className="bold text-left blue-color bold mt-5" style={{paddingLeft: '20px'}}> Login </h5>
                    <Col md="12" className="padding-top-20">
                      <FormGroup>
                        <Input className="input-material-black box-shadow-none" type="email" name="email" defaultValue={this.state.student.email} onChange={this.handleChangeLogin} id="email"  placeholder="Email Id" required />
                      </FormGroup>
                    </Col>
                    <Col md="12" className="">
                      <FormGroup>
                        <Input className="input-material-black box-shadow-none" type="password" name="password" defaultValue={this.state.student.password} onChange={this.handleChangeLogin} id="password" placeholder="Password"  required />
                      </FormGroup>
                    </Col>
                  </FormGroup>
                  <Col md="10" className="center px-0" style={{marginBottom: '2.5rem'}}>
                    <Button type="submit" color="primary" className="btn btn-pill rounded-bordered buybtn" style={{fontSize: '1.1rem'}}>Login</Button>
                  </Col>
                  <Col md="10" className="center px-0">
                    <Button onClick={() => {this.openSignup()}}  color="primary" className="mb-2 btn btn-pill rounded-bordered buybtn loginformbtn">Signup</Button>
                    <Button onClick={() => {this.openForgotForm()}} id="login-with-otp" color="primary" className="mb-2 btn btn-pill m-l-10 rounded-bordered buybtn loginformbtn">Forgot Password? Login using OTP</Button>
                  </Col>
                </Form>
                <Form onSubmit={this.handleForgotPassword} id="forgot_form" style={{paddingBottom: '4rem', display: this.state.forgot_form_visibility}} >
                  <FormGroup row className="col-10 center">
                    <h5 className="bold text-left blue-color bold mt-5" style={{paddingLeft: '20px'}}> Login using OTP </h5>
                    <Col md="12" className="padding-top-20">
                      <FormGroup>
                        <Input className="input-material-black" type="email" name="email" defaultValue={this.state.student.email} onChange={this.handleChangeLogin} id="email" placeholder="Email Id" required />
                        <Input className="input-material-black" type="password" name="otp" defaultValue={this.state.student.otp} onChange={this.handleChangeLogin} id="otp" placeholder="OTP" required style={{display: this.state.otp}} />
                      </FormGroup>
                    </Col>
                  </FormGroup>
                  <Col md="10" className="center px-0" style={{display: this.state.loginbtn, marginBottom: '2.5rem'}}>
                    <Button type="submit" color="primary" className="btn btn-pill rounded-bordered" style={{fontSize: '1.1rem'}}>Login</Button>
                  </Col>
                  <Col md="10" className="center px-0" style={{display: this.state.otpbtn, marginBottom: '2.5rem'}}>
                    <Button onClick={() => {this.generateOTP()}}  color="primary" className="btn btn-pill rounded-bordered" style={{fontSize: '1.1rem'}}>Generate OTP</Button>
                  </Col>
                  <Col md="10" className="center px-0">
                    <Button onClick={() => {this.openSignup()}}  color="primary" className="mb-2 btn btn-pill rounded-bordered buybtn loginformbtn" >Signup</Button>
                    <Button onClick={() => {this.openLoginForm()}}  color="primary" className="mb-2 btn btn-pill m-l-10 rounded-bordered buybtn loginformbtn" >Login using Password</Button>
                  </Col>
                </Form>
                <p className="float-left mb-0 pb-3" style={{fontSize: '12px'}}> By clicking Sign Up/Login, you agree to our <a className="blue-color" href="/terms-and-conditions/" >Terms</a> and <a className="blue-color" href="/privacy-policy/" > Privacy Policy</a>  </p>
              </Col>
            </Row>
            <Row className="text-center padding-top-40">
            </Row>
            <Row className="text-center padding-top-40"/>
          </section>
        </Modal>
        <Modal classNames={{modal: 'modal-contact'}} closeButton={'avcc'} open={this.state.contactopen} onClose={this.toggleContactModal} center >
          <Row>
            <Container className="vertical-mid-modal-content text-center mt-5 mb-4">
              <h1 className="large-font text-center text-primary"> Contact Us </h1>
              <div>
                <button className='btn transparent no-padding white-text font-very-large pull-right' onClick={this.toggleContactModal}>
                  X
                </button>
              </div>
              <Form className="center col-10" onSubmit={this.handleEnquiry}>
                <FormGroup>
                  <InputGroup className="box-shadow">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText><i className="fa fa-user"></i></InputGroupText>
                    </InputGroupAddon>
                    <Input type="text" id="enquiry_name" name="name" placeholder="Name" defaultValue={this.state.enquiry.name} onChange={this.handleEnquiryChange} autoComplete="name" required/>
                  </InputGroup>
                </FormGroup>
                <FormGroup>
                  <InputGroup className="box-shadow">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText><i className="fa fa-envelope"></i></InputGroupText>
                    </InputGroupAddon>
                    <Input type="email" id="enquiry_email" name="email" placeholder="Email" defaultValue={this.state.enquiry.email} onChange={this.handleEnquiryChange} autoComplete="email" required/>
                  </InputGroup>
                </FormGroup>
                <FormGroup>
                  <InputGroup className="box-shadow">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText><i className="fa fa-phone"></i></InputGroupText>
                    </InputGroupAddon>
                    <Phone className="enquiry_form_control" type="phone" id="enquiry_phone" name="mobile" placeholder="Phone Number" displayInitialValueAsLocalNumber country="IN" value={this.state.enquiry.mobile} onChange={this.handleEnquiryPhone} autoComplete="phone" required/>
                  </InputGroup>
                </FormGroup>
                <FormGroup>
                  <InputGroup className="box-shadow">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText><i className="fa fa-envelope"></i></InputGroupText>
                    </InputGroupAddon>
                    <Input type="textarea" id="enquiry_message" name="message" placeholder="Message" defaultValue={this.state.enquiry.message} onChange={this.handleEnquiryChange} autoComplete="message" required/>
                  </InputGroup>
                </FormGroup>
                <FormGroup className="form-actions">
                  <Button type="submit" size="lg" className="col-12" color="primary">Submit</Button>
                </FormGroup>
              </Form>
            </Container>
          </Row>
        </Modal>
      </Row>
    );
  }
}

DefaultProductHeader.propTypes = propTypes;
DefaultProductHeader.defaultProps = defaultProps;

export default DefaultProductHeader;
